<template>
    <div class="contentWrap joinsect">
        <div class="peopleNum">
            <p>已有 <span>{{peopleNum}}</span>位兄弟再次集结 </p>
             <span>5月20日新服【渡劫封仙】爆燃开启</span>
        </div>

    </div>
</template>
<script>
import { GetTotalUserCount } from '@/untils/authority'
export default {
    name:'index',

    data(){
        return {
            peopleNum:0

        }
    },
    mounted(){
        this.GetTotalUserCountFn()
    },
    methods:{
           // 获取用户数量
        GetTotalUserCountFn(){
            GetTotalUserCount().then(response => {
                if(response.result == 1){
                    this.peopleNum = response.data
                }else{

                }
            })
        },
        closeModal(){
          this.dialogFormVisible = false
        }
    }
}
</script>
<style lang="less">
.contentWrap{
     background:url('../assets/bg.jpg');
     width:100%;
     background-position: center;
     height:100vh;
}

.joinsect{
    position: relative;
    .peopleNum{
        // padding-top:61%;
        // float:right;
        // padding-right:20%;
        position: absolute;
    //   osition: fixed;
    bottom: 19vh;
    left: 50vw;
        >p{
           color: #ffffff; 
           	font-size: 37px;
               width: 598px;
	height: 71px;
    background:url('../assets/desire_bg.png');
    text-align: center;
            span{
                color: #e6a417;
                font-size: 53px;
              
            }
        }
        >span{
              width: 598px;
                display: block;
                text-align: center;
            display: block;
            padding-top:20px;
            color: #282950;
            	font-size: 34px;
        }
    }
}
</style>